export default "__VITE_ASSET__3TTYWxsm__"